export function endOfPage(offset = 0) {
  if (
    (window.pageYOffset || document.body.scrollTop) + window.innerHeight >=
    document.getElementById('site-container').offsetHeight - offset
  ) {
    return true;
  } else return false;
}
